export interface PrintCallbackMessage {
    type: PrintCallbackType;
    message?: string;
}

export enum PrintCallbackType {
    DataLoadingError = 'DataLoadingError',
    PrintReadyForWrapper = 'PrintReadyForWrapper',
    PrintStarted = 'PrintStarted',
    PrintFinished = 'PrintFinished',
}

export enum PrintDeviceType {
    Default = 'Default',
    Android = 'Android',
    Ios = 'Ios',
}
